package org.moxultimate.topwithmox.components.searchbar

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.dom.svg.Path
import com.varabyte.kobweb.compose.dom.svg.Svg
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs

/**
 * SearchIcon
 * Inline SVG magnifying-glass icon that replaces FaMagnifyingGlass.
 * Eliminates the 3.3 MB Font Awesome CDN CSS dependency from every page load.
 * Uses stroke="currentColor" so Modifier.color() controls the icon tint.
 */
@Composable
fun SearchIcon(modifier: Modifier = Modifier) {
    Svg(
        attrs = modifier.toAttrs {
            attr("viewBox", "0 0 24 24")
            attr("width", "16")
            attr("height", "16")
            attr("fill", "none")
            attr("stroke", "currentColor")
            attr("stroke-width", "2.5")
            attr("stroke-linecap", "round")
            attr("stroke-linejoin", "round")
            attr("aria-hidden", "true")
        }
    ) {
        Path {
            d("M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z")
        }
    }
}
